<template>
  <path
    d="M21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002ZM8.9 13.9802L11 16.5102L14.1 12.5202C14.3 12.2602 14.7 12.2602 14.9 12.5302L18.41 17.2102C18.66 17.5402 18.42 18.0102 18.01 18.0102H6.02C5.6 18.0102 5.37 17.5302 5.63 17.2002L8.12 14.0002C8.31 13.7402 8.69 13.7302 8.9 13.9802Z"
  />
</template>
